import '../../../../../components/room-cards-carousel.js.es6';
import '../../../../../components/room-pricing-table.js.es6';
import '../../../../../components/history-state.js.es6';
import '../../../../../components/selection-tracking.es6';
import '../../../../../components/home-search.js.es6';
import '../../../../../components/accordion.js.es6';
import '../../../../../js/views/venue/location_venue_page.js';
import '../../../../../js/shared/RwdHelper.js';
import '../../../../../js/views/shared/google_map_popup.js.es6';
import '../../../../../js/views/shared/detect_device.js';
import '../../../../../es6/views/venue/maps_callback.js.es6';
import '../../../../../es6/shared/fill_variables.js.es6';
import '../../../../../es6/shared/in-view.js.es6';
import '../../../../../es6/shared/in-view-test-function.js.es6';
import '../../../../../es6/shared/lory_carousel.js.es6';
import '../../../../../es6/shared/google_places_manager.js.es6';
import '../../../../../es6/shared/storage_manager.js.es6';
import '../../../../../es6/shared/wish_list.js.es6';
import '../../../../../es6/shared/session-flash.es6';
import '../../../../../es6/shared/track_click.js.es6';
import '../../../../../es6/shared/tags_autocomplete.js.es6';
import '../../../../../es6/shared/tags_storage.js.es6';
import '../../../../../es6/shared/preload.js.es6';
import '../../../../../es6/shared/expiring_data_manager.js.es6';
import '../../../../../es6/shared/wait-for.js.es6';
import '../../../../../es6/shared/debounce.js.es6';
import '../../../../../js/shared/collapseContent.js';
import '../../../../../js/views/room/truncate.js';
import '../../../../../js/views/room/modal.js.es6';
import './venuepage.main.js';

import { mountApp } from '@/services/config';

import VenuePageWrapper from './components/VenuePageWrapper.vue';

$(() => {
  mountApp(VenuePageWrapper, '#app');
});

document.querySelectorAll('.js-open-reviews-modal, .js-venuepage-reviews, .js-venuepage-reviews-button').forEach((el) => {
  el.addEventListener('click', () => {
    window.triggerShowReviewsModal();
  });
});
